import React, { useEffect, useState } from "react";
import { BooleanField, classnames, Icon } from "@culturehq/components";

import { ApprovedForSocial, Story, StoryQuestion } from "chq";
import { useProfile } from "app/context";
import { Trans } from "app/utils";

import { StoryWithNullableQuestion } from "components/stories/post-stories-v2/types";
import JobPostingMappingModal from "./job-posting-modal/JobPostingMappingModal";

interface JobMappingProps {
  approvedForSocial?: ApprovedForSocial;
  mappersValueIds?: string[];
  story?: Story | StoryWithNullableQuestion;
  storyQuestion?: StoryQuestion;
  onUpdate: (value: ApprovedForSocial | Story | Record<string, string[]>) => void;
}

const ApproveForJobMappingButton: React.FC<JobMappingProps> = ({
  approvedForSocial, mappersValueIds, story, storyQuestion, onUpdate
}) => {
  const currentStory = story || approvedForSocial?.entity;
  const [cmkMarked, setCmkMarked] = useState(false);
  const { profile: { organization } } = useProfile();

  useEffect(
    () => {
      setCmkMarked((currentStory?.externalMapperValueAssociations?.length || 0) > 0
        || (storyQuestion?.parentStoryQuestion?.externalMapperValueAssociations?.length || 0) > 0
        || (storyQuestion?.externalMapperValueAssociations?.length || 0) > 0);
    }, [currentStory, storyQuestion]
  );

  if (!organization.externalMappedIds) {
    return <></>;
  }

  const handleUpdate = (value: ApprovedForSocial | Story | Record<string, string[]>) => {
    if (typeof value === "object" && (value as Record<string, string[]>).mappersValueIds) {
      setCmkMarked((value as Record<string, string[]>).mappersValueIds.length > 0);
    }
    onUpdate(value);
  };

  return (
    <>
      <JobPostingMappingModal
        approvedForSocial={approvedForSocial}
        mappersValueIds={mappersValueIds}
        onUpdate={handleUpdate}
        story={story}
        storyQuestion={storyQuestion}
      >
        {
          (onTrigger: any) => (
            <div onClick={onTrigger}>
              <BooleanField
                value={cmkMarked}
                name="mapped"
                onChange={value => {}}
                className={classnames("Mapped-cmk", { "Mapped-cmk-marked": cmkMarked })}
                aria-label="Mapped"
              >
                <Trans>Mapped</Trans>
                <Icon className="connection" icon="connections" />
              </BooleanField>
            </div>
          )

        }
      </JobPostingMappingModal>
    </>
  );
};

export default ApproveForJobMappingButton;
